import React from 'react';

const MongoDB_Home = () => {
  return (
    <div>
      <h1>MongoDB_Home Component</h1>
      <p>This is the MongoDB_Home page.</p>
    </div>
  );
};

export default MongoDB_Home;
